'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _default = require('../config/default');

var _default2 = _interopRequireDefault(_default);

var _overrides = require('../config/overrides');

var _overrides2 = _interopRequireDefault(_overrides);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var typeNotPresent = function typeNotPresent(type) {
  return new Error('ApiClient cant initialize with type: ' + type + ',\n  please make sure the settings do exist in the ApiClient config');
};

var ConfigBuilder = function () {
  function ConfigBuilder(client, defaultConfig) {
    _classCallCheck(this, ConfigBuilder);

    this.client = client;

    this.baseConfig = defaultConfig;
  }

  _createClass(ConfigBuilder, [{
    key: '_setBasicConfigOverrides',
    value: function _setBasicConfigOverrides(requestType) {
      if (!_overrides2.default[this.client.resourceType]) throw typeNotPresent(this.client.resourceType);

      var configOverrides = _overrides2.default[this.client.resourceType][requestType];

      this.baseConfig = Object.assign({}, _default2.default, _extends({}, configOverrides));
    }
  }, {
    key: '_setUpdateConfigOverrides',
    value: function _setUpdateConfigOverrides(method, options) {
      var basePath = this.baseConfig.update_path || this.baseConfig.path;
      var updatePath = options.id ? basePath + '/' + options.id : basePath;
      var optionsId = method !== 'POST' && { id: options.id || '1' };

      this.baseConfig = Object.assign({}, this.baseConfig, {
        method: method,
        path: updatePath,
        data: {
          data: _extends({}, this.baseConfig.data.data, {
            type: this.client.resourceType
          }, optionsId, {
            attributes: options.attributes
          })
        },
        content_type: 'application/vnd.api+json'
      });
    }
  }, {
    key: '_setFileUploadConfigs',
    value: function _setFileUploadConfigs(options) {
      var attributes = options.file_upload.attributes;

      var formData = new FormData();
      formData.append('file_type', attributes.type);

      if (attributes.file) formData.append('file', attributes.file);
      if (attributes.cropSettings) formData.append('cropSettings', JSON.stringify(attributes.cropSettings));

      this.baseConfig = Object.assign({}, this.baseConfig, {
        method: 'PUT',
        data: formData,
        content_type: 'multipart/form-data',
        accept_header: 'application/json',
        timeout: 50000
      });

      return this.client;
    }
  }, {
    key: '_setDeleteFileUploadConfigs',
    value: function _setDeleteFileUploadConfigs(options) {
      this.baseConfig = Object.assign({}, this.baseConfig, {
        method: 'DELETE',
        data: _extends({}, options.attributes),
        accept_header: 'application/json'
      });
    }
  }, {
    key: '_setParams',
    value: function _setParams(options) {
      this.baseConfig = Object.assign({}, this.baseConfig, {
        params: _extends({}, options)
      });
    }
  }, {
    key: '_setOptions',
    value: function _setOptions(options) {
      this.baseConfig = Object.assign({}, this.baseConfig, {

        data: _extends({}, this.baseConfig.data, options)
      });
    }
  }, {
    key: '_setMeta',
    value: function _setMeta(options) {
      return this._setOptions({ meta: _extends({}, options) });
    }
  }, {
    key: '_setFilter',
    value: function _setFilter(options) {
      console.warn(options);
      return this._setParams({ filter: _extends({}, options) });
    }
  }, {
    key: '_setSearchFilter',
    value: function _setSearchFilter(options) {
      return this._setFilter({ search: _extends({}, options) });
    }
  }, {
    key: '_setSinglePath',
    value: function _setSinglePath(options) {
      this.baseConfig = Object.assign({}, this.baseConfig, {
        path: this.baseConfig.path + '/' + options.id
      });
    }
  }]);

  return ConfigBuilder;
}();

exports.default = ConfigBuilder;